import axios from "axios";
import router from '../../router/index';
import { createPaginatedStateWithSummary, handlePaginatedResponse } from '../helpers/paginationState';


export const state = {
    sales: [],
    untaken_orders: [],
    debtors: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
    }),
    save_status: false,
    filter_status: false,
    sales_analysis: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
    }),
    imported_debtors: [],
    saleId: '',
    discounts:createPaginatedStateWithSummary(50, {
        totalAmount: 0,
        totalDiscount: 0,
    }),
    use_sales_summary: [],
    consumption: [],
    sales_report: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
        totalCost: 0,
        totalDiscount: 0
    }),
     sales_data: createPaginatedStateWithSummary(50, {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
    }),
    debtors_data:createPaginatedStateWithSummary(50, {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
        totalBalance: 0,
    }),
    sales_report_data:createPaginatedStateWithSummary(50, {
        totalAmount: 0,
        totalCost:0,
        totalDiscount:0
    }),
    fetch_sale_details: false,

};

export const getters = {
    UntakenOrders: state => state.untaken_orders.data,
    Sales: state => state.sales.data,
    DiscountsData: state => state.discounts.data,
    DiscountsDataPagination: state => state.discounts.meta,
    IsDiscountsDataServerPaginated: state => state.discounts.isServerPaginated,
    DiscountsDataSummary: state => state.discounts.summary,
    DiscountsDataPaginated: state => state.discounts.data,
    SalesReport: state => state.sales_report.data,
    SalesReportPagination: state => state.sales_report.meta,
    SalesReportPaginated: state => state.sales_report.data,
    IsSalesReportServerPaginated: state => state.sales_report.isServerPaginated,
    SalesReportSummary: state => state.sales_report.summary,
    Debtors: state => state.debtors.data,
    DebtorsPagination: state => state.debtors.meta,
    DebtorsPaginated: state => state.debtors.data,
    IsDebtorsServerPaginated: state => state.debtors.isServerPaginated,
    DebtorsSummary: state => state.debtors.summary,
    SalesId: state => state.saleId,
    ImportedDebtors: state => state.imported_debtors.data,
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
    SalesAnalysis: state => state.sales_analysis.data,
    SalesAnalysisPagination: state => state.sales_analysis.meta,
    SalesAnalysisPaginated: state => state.sales_analysis.data,
    IsSalesAnalysisServerPaginated: state => state.sales_analysis.isServerPaginated,
    SalesAnalysisSummary: state => state.sales_analysis.summary,

    UserSalesSummary: state => state.use_sales_summary,
    Consumption: state => state.consumption,
    SalesData: state => state.sales_data.data,
    SalesPagination: state => state.sales_data.meta,
    SalesPaginated: state => state.sales_data.data,
    SalesSummary: state => state.sales_data.summary,
    IsSalesServerPaginated: state => state.sales_data.isServerPaginated,
    DebtorsData: state => state.debtors_data.data,
    DebtorsDataPagination: state => state.debtors_data.meta,
    DebtorsDataPaginated: state => state.debtors_data.data,
    DebtorsDataSummary: state => state.debtors_data.summary,
    IsDebtorsDataServerPaginated: state => state.debtors_data.isServerPaginated,
    SalesReportData: state => state.sales_report_data.data,
    SalesReportDataPagination: state => state.sales_report_data.meta,
    SalesReportDataPaginated: state => state.sales_report_data.data,
    IsSalesReportDataServerPaginated: state => state.sales_report_data.isServerPaginated,
    SalesReportDataSummary: state => state.sales_report_data.summary,
    getSaleDetails: state => state.fetch_sale_details,

};
export const mutations = {
    SET_SALES(state, newValue) {
        state.sales = newValue
    },
    SET_DISCOUNTS(state, response) {
        handlePaginatedResponse(state.discounts, response);
    },
    RESET_DISCOUNTS_PAGINATION(state) {
        state.discounts.data = [];
        state.discounts.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
        state.discounts.summary = { totalAmount: 0, totalDiscount: 0 };
        state.discounts.isServerPaginated = false;
    },
    SET_SALES_REPORT(state, response) {
        handlePaginatedResponse(state.sales_report, response);
    },
    SET_UNTAKEN(state, newValue) {
        state.untaken_orders = newValue
    },
    SET_DEBTORS(state, response) {
        handlePaginatedResponse(state.debtors, response);
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_SALES_ANALYSIS(state, response) {
        handlePaginatedResponse(state.sales_analysis, response);
    },
    SET_IMPORTED_DEBTORS(state, newValue) {
        state.imported_debtors = newValue
    },
    SET_SALE_ID(state, newValue) {
        state.saleId = newValue
    },
    SET_USER_SALES_SUMMARY(state, newValue) {
        state.use_sales_summary = newValue
    },
    SET_CONSUMPTION(state, newValue) {
        state.consumption = newValue
    },
    SET_SALES_DATA(state, response) {
        handlePaginatedResponse(state.sales_data, response);
    },
    RESET_SALES_PAGINATION(state) {
        state.sales_data.data = [];
        state.sales_data.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0, total: 0 };
        state.sales_data.summary = { totalAmount: 0, totalPaid: 0, totalDiscount: 0, totalBalance: 0 };
        state.sales_data.isServerPaginated = false;
    },
    SET_DEBTORS_DATA(state, response) {
        handlePaginatedResponse(state.debtors_data, response);
    },
    RESET_DEBTORS_PAGINATION(state) {
        state.debtors_data.data = [];
        state.debtors_data.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0, total: 0 };
        state.debtors_data.summary = { totalAmount: 0, totalPaid: 0, totalDiscount: 0, totalBalance: 0 };
        state.debtors_data.isServerPaginated = false;
    },
    SET_SALES_REPORT_DATA(state, response) {
        handlePaginatedResponse(state.sales_report_data, response);
    },
    RESET_SALES_REPORT_PAGINATION(state) {
        state.sales_report_data.data = [];
        state.sales_report_data.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0, total: 0 };
        state.sales_report_data.summary = { totalAmount: 0 };
        state.sales_report_data.isServerPaginated = false;
    },
    SET_FETCH_SALEDETAILS(state, newValue) {
        state.fetch_sale_details = newValue
    },
};
export const actions = {
    editAmtPaidMode({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`update_amt_paid/${payload.id}`, payload).then((response) => {
            if (response.status == 201) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })

            } else {
                let message = { 'msg': `Sale Amount Paid updated successfully` }
                dispatch('notification/success', message, { root: true })

            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Paid Amount" }
            dispatch('notification/error', message, { root: true })
        })
    },
    editSale({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`sales/${payload.id}`, payload).then((res) => {
            if (res.status == 200) {
                commit('SET_SAVE_STATUS', false);
                router.push('/sales/order').catch(() => {});
            } else {
                commit('SET_SAVE_STATUS', false);
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })

            }            
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Returning Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteSale({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('delete_sale', payload).then(() => {
            dispatch('fetchSalesData', payload.filterdata);
            let message = { 'msg': `Sale Deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Clear Debt
    ClearDebt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        let amount = payload.paid;
        axios.put(`pay_debt/${payload.id}`, payload).then((response) => {
            if (response.status == 200) {
                if (payload.filterdata) {
                    dispatch('fetchDebtorsData', payload.filterdata);
                }
                let message = { 'msg': `Debt of ${amount} Cleared successfully` }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Clearing Debt" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Clear Debt Print
    ClearDebtPrint({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`pay_debt/${payload.id}`, payload).then((res) => {
            if (res.data.status == 200) {
                if (payload.filterdata) {
                    dispatch('fetchDebtorsData', payload.filterdata);
                }
                commit('SET_SAVE_STATUS', false);
                commit('SET_SALE_ID', res.data.id)
            } else {
                commit('SET_SAVE_STATUS', false);
                let message = { 'msg': "Failed to record Payment" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Clearing Debt" }
            dispatch('notification/error', message, { root: true })
        })
    },


    // Clear debt
    ClearImportedDebt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`clear_importeddebtors/${payload.id}`, payload).then(() => {
            dispatch('fetchImportedDebtors');
            let message = { 'msg': `Debt of ${payload.paid} Cleared successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Clearing Debt" }
            dispatch('notification/error', message, { root: true })
        })
    },

    submitSale({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`submit_sales/${payload.id}`, payload).then((response) => {
            commit('SET_SAVE_STATUS', false);            
            if (response.status==200){
                dispatch('fetchSalesData', payload.filterdata);
                let message = { 'msg': `Sale submitted successfully` }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==202){
                let message = { 'msg': response.data.message+'!!  Kindly correct this and syncronize the sale' }
                dispatch('notification/error', message, { root: true })
            }else{
                let message = { 'msg': "Failed to synchronize Sale" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Resubmitting Sale" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchDebtors({ commit, dispatch }, payload={}) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
        
        axios.post('debtors', apiPayload).then(response => {
            commit('SET_DEBTORS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_DEBTORS', { data: [], meta:{}, summary: { totalAmount: 0 ,totalPaid:0, totalDiscount: 0, totalBalance: 0} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load debtors report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },
    
    fetchImportedDebtors({ commit }) {
        axios.get('imported_debtors').then(total => {
            commit('SET_IMPORTED_DEBTORS', total.data)
        })
    },

    EditDebt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`edit_importeddebtors/${payload.id}`, payload).then(() => {
            dispatch('fetchImportedDebtors');
            let message = { 'msg': `Debt for ${payload.customer} edited successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Editing Debt" }
            dispatch('notification/error', message, { root: true })
        })
    },

    DeleteDebt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`delete_importeddebtors/${payload.id}`).then(() => {
            dispatch('fetchImportedDebtors');
            let message = { 'msg': `Debt for ${payload.customer} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Debt" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchImportedDebtorDetails({ commit }, id) {
        axios.get(`imported_debtor_details/${id}`).then(total => {
            commit('SET_IMPORTED_DEBTORS', total.data)
        })
    },

    fetchSales({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post('sales_data', payload).then(total => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_SALES', total.data)
        })
    },
    fetchSaleDetails({ commit }, id) {
        commit('SET_FILTER_STATUS', true)
        axios.get(`sale_details/${id}`).then(total => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_FETCH_SALEDETAILS', total.data)
        })
    },
    fetchSalesReport({ commit, dispatch }, payload) {
         commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
        
        axios.post('sales_report', apiPayload).then(response => {
            commit('SET_SALES_REPORT', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALES_REPORT', { data: [], meta:{}, summary: { totalAmount: 0 ,totalCost:0, totalDiscount: 0} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load sales report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },
    
    fetchSalesReportData({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
        
        axios.post('sales_report', apiPayload).then(response => {
            commit('SET_SALES_REPORT_DATA', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALES_REPORT_DATA', { data: [], meta:{}, summary: { totalAmount: 0 ,totalCost:0, totalDiscount: 0} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load sales report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },
    
    fetchUnTakenOrders({ commit }) {
        axios.get(`untaken_orders`).then(total => {
            commit('SET_UNTAKEN', total.data)
        })
    },

    fetchSalesAnalysis({ commit, dispatch}, payload) {
         commit('SET_FILTER_STATUS', true);

        let apiPayload = { ...payload };

        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? state.discounts.meta.per_page;
      

        axios.post('sales_analysis', apiPayload).then(response => {
            commit('SET_SALES_ANALYSIS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALES_ANALYSIS', { data: [], meta:{}, summary: { totalAmount: 0} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load sales analysis report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    editPaydate({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`update_paydate/${payload.id}`, payload).then(() => {
            let message = { 'msg': `Payment Date updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Payment Date" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchDiscounts({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);

        let apiPayload = { ...payload };

        apiPayload.page = payload.page ?? 50;
        apiPayload.per_page = payload.per_page ?? state.discounts.meta.per_page;
      

        axios.post('discounts_allowed', apiPayload).then(response => {
            commit('SET_DISCOUNTS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_DISCOUNTS', { data: [], meta:{}, summary: { totalAmount: 0, totalDiscount: 0 } });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load discounts report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchUserSalesSummary({ commit }, payload) {
        commit('SET_FILTER_STATUS', true);
        axios.post('userSales', payload).then(res => {
            commit('SET_FILTER_STATUS', false);
            commit('SET_USER_SALES_SUMMARY', res.data);
        })
    },
    fetchProductionConsumption({ commit }, payload) {
        commit('SET_FILTER_STATUS', true);
        axios.post('consumption', payload).then(res => {
            commit('SET_FILTER_STATUS', false);
            commit('SET_CONSUMPTION', res.data);
        })
    },

    fetchSalesData({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;

        axios.post('sales_data', apiPayload).then(response => {
            commit('SET_SALES_DATA', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_SALES_DATA', { data: [], meta:{}, summary: { totalAmount: 0, totalPaid: 0, totalDiscount: 0, totalBalance: 0 } });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load sales report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchDebtorsData({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);

        let apiPayload = { ...payload };

            apiPayload.page = payload.page ?? 1;
            apiPayload.per_page = payload.per_page ?? 50;
        

        axios.post('debtors', apiPayload).then(response => {
            commit('SET_DEBTORS_DATA', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch(() => {
            commit('SET_DEBTORS_DATA', { data: [], meta:{}, summary: { totalAmount: 0, totalPaid: 0, totalDiscount: 0, totalBalance: 0 } });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load debtors report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

};